import { useState } from 'react';
import { storeService } from '../services/storeService';
import { StoreProductDetail } from '../models';
import { useCartStore } from '../store/cartStore';
import { useToastStore } from '../store/toastStore';

const UNLIMITED_STOCK = Number.MAX_SAFE_INTEGER;

export function useQuickAdd(productId: number) {
  const addItem = useCartStore((s) => s.addItem);
  const showToast = useToastStore((s) => s.show);

  const [isFetching, setIsFetching] = useState(false);
  const [modalProduct, setModalProduct] = useState<StoreProductDetail | null>(null);

  const openQuickAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (isFetching) return;

    setIsFetching(true);
    storeService
      .getProduct(productId)
      .then((detail) => {
        if (detail.variants.length === 0) {
          if (detail.price === null) return;
          const result = addItem({
            productId: detail.id,
            variantId: 0,
            productName: detail.name,
            variantLabel: '',
            price: detail.price,
            promotionalPrice: detail.promotionalPrice,
            imageUrl: detail.images[0]?.imageUrl ?? '',
            quantity: 1,
            stockQuantity: UNLIMITED_STOCK,
          });
          showToast(result === 'max_stock' ? 'Quantidade máxima em estoque atingida.' : 'Produto adicionado ao carrinho!', result === 'max_stock' ? 'error' : 'success');
          return;
        }
        setModalProduct(detail);
      })
      .catch(() => showToast('Não foi possível carregar este produto.', 'error'))
      .finally(() => setIsFetching(false));
  };

  const closeQuickAdd = () => setModalProduct(null);

  return { isFetching, modalProduct, openQuickAdd, closeQuickAdd };
}
